import { render, staticRenderFns } from "./NeutralEmoji.vue?vue&type=template&id=0bf866d8"
import script from "./NeutralEmoji.vue?vue&type=script&lang=js"
export * from "./NeutralEmoji.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports